module.exports = __webpack_public_path__ + "assets/img/0e6f8259ebd479e0baf176bc3122cd83.svg";